import React, { lazy, Suspense } from 'react';
import { Box } from '@mui/material';
import { useSalesExport } from '../hooks/useSalesExport';
import { debitExportColumns, exportFormats } from '../data/exportData';
import { ExportPageSkeleton } from '../components/ExportPageSkeleton';

// Lazy load components and data
const ExportHeader = lazy(() => import('../components/exportForm/ExportHeader').then((m) => ({ default: m.ExportHeader })));
const ColumnSelector = lazy(() => import('../components/exportForm/ColumnSelector').then((m) => ({ default: m.ColumnSelector })));
const ExportActions = lazy(() => import('../components/exportForm/ExportActions').then((m) => ({ default: m.ExportActions })));
const LoadingModal = lazy(() => import('../../../components/_components').then((m) => ({ default: m.LoadingModal })));

export const DebitExportPage: React.FC = () => {
  const {
    selected,
    selectedModule,
    setSelectedModule,
    dateRange,
    errors,
    exportStatus,
    isOpen,
    downloadCallback,
    handleChange,
    handleSelectAll,
    handleDateRangeChange,
    handleExport,
    handleCloseModal,
    handleExit,
  } = useSalesExport();

  return (
    <Box>
      <Suspense fallback={<ExportPageSkeleton />}>
        <ExportHeader
          title="Debit invoice Export"
          selectedModule={selectedModule}
          setSelectedModule={setSelectedModule}
          dateRange={dateRange}
          handleDateRangeChange={handleDateRangeChange}
          moduleOptions={[...exportFormats]}
          errors={errors}
        />

        <ColumnSelector columns={debitExportColumns} selected={selected} handleChange={handleChange} handleSelectAll={handleSelectAll} />

        <ExportActions
          onExport={handleExport}
          exportDisabled={!selectedModule || selected.length === 0 || !dateRange}
          onExit={handleExit}
        />

        <LoadingModal
          open={isOpen}
          status={exportStatus}
          onClose={handleCloseModal}
          downloadCallback={downloadCallback}
          loadingTitle="Exporting Data"
          successTitle="Export Completed"
          errorTitle="Export Failed"
          loadingMessages={['Preparing export...', 'Processing data...', 'Generating file...', 'Almost ready...', 'Finalizing export...']}
          successMessage="Your file has been downloaded successfully!"
          errorMessage="Failed to export file. Please try again."
        />
      </Suspense>
    </Box>
  );
};
